import BasicModal from '../../../components/modals/BasicModal';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export const TextLimitModal = ({ showModal, error, setShowModal }) => {
  if (!error) {
    return <></>;
  }

  return (
    <BasicModal
      showModal={showModal}
      setShowModal={setShowModal}
      title="Sorry, that's too much text"
      iconBackground='bg-amber-100'
      icon={<ExclamationTriangleIcon className='w-auto p-0.5 h-6 auto-group text-amber-500' />}>
      <TextLimitModalInnerFreemium error={error} setShowModal={setShowModal} />
    </BasicModal>
  );
};

const WHITE_BUTTON_CLASSES =
  'inline-flex w-full justify-center items-center font-semibold whitespace-nowrap gap-1 rounded-md bg-none px-4 py-2 ring-1 ring-gray-200 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500';

const Y_MARGIN_CLASS = 'mt-4';

// Everyone shares one limit, so show it plainly with no free/premium split and no
// upgrade CTA.
const TextLimitModalInnerFreemium = ({ error, setShowModal }) => {
  return (
    <div className='text-center'>
      <p className='text-gray-500'>
        Your {error.text_type === 'video_transcript' ? "video's transcript" : 'text'} had{' '}
        <span className='text-amber-600 font-bold'>{error.text_length.toLocaleString()}</span>{' '}
        characters, and Diffit can only process{' '}
        {error.text_type === 'video_transcript' ? 'transcripts' : 'text'} up to{' '}
        <span className='text-gray-600 font-semibold'>
          {error.max_length_premium.toLocaleString()}
        </span>{' '}
        characters.
      </p>
      <div className='flex'>
        <button
          className={`${Y_MARGIN_CLASS} ${WHITE_BUTTON_CLASSES}`}
          onClick={() => setShowModal(false)}>
          Try A Different {error.text_type === 'video_transcript' ? 'Video' : 'Text'}
        </button>
      </div>
    </div>
  );
};
